import { render, staticRenderFns } from "./DirectRequiredModal.vue?vue&type=template&id=70ff9688"
import script from "./DirectRequiredModal.vue?vue&type=script&lang=js"
export * from "./DirectRequiredModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports